import React from 'react';
import { IconBaseProps } from 'react-icons';
import { FaPlus } from 'react-icons/fa';

const Plus: React.FC<IconBaseProps> = (props) => <FaPlus {...props} />;

export default Plus;
